import React, { useEffect, useState } from 'react'
import { Box, Button, CircularProgress, Dialog, DialogContent, DialogActions, Typography, TextField, Card, Grid, CardContent } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import { useDataProvider, Loading, useTranslate, usePermissions } from 'react-admin'
import TransferList from '../CustomizedUIs/TransferList'
import IconRadiusButton from '../CustomizedUIs/IconRadiusButton'
import { Close } from '@material-ui/icons'
import colors from '../CustomizedUIs/Colors'
import CustomPoper from '../CustomizedUIs/CustomPoper'
import { red, pink } from '@material-ui/core/colors';
import { baseApiUrl } from '../dataProvider/sails';
import DialogChooseFile from '../file-management/file-management-dialog'
import { isAudio, isImage, isVideo, isMedia } from '../utils';
import CloseButton from '../CustomizedUIs/CloseButton'

const bgColorError = pink['50'];
const textColorError = red['700'];

const useStyles = makeStyles(theme => ({
    input: {
        backgroundColor: 'white',
        borderRadius: '2px',
        "&:hover": {
            backgroundColor: 'white'
        }
    },
    underline: {
        '&::before': {
            borderBottom: '1px solid black'
        },
        '&:hover:before': {
            borderBottom: '1px solid black'
        }
    },
    large: {
        marginLeft: 16,
        border: '1px solid #ddd',
        borderRadius: '50%',
        padding: 2,
        width: 100,
        height: 100,
        '&:hover': {
            boxShadow: '0 0 2px 1px rgba(0, 140, 186, 0.5)'
        }
    },
    borderImage: {
        borderRadius: '10px',
        backgroundColor: '#c1e5fa',
        '&:hover': {
            backgroundColor: '#a7cce7',
        }
    },
    underlineNotValue: {
        '&::before': {
            borderBottom: '1px solid' + colors.lightBlue['200']
        },
        '&:hover:before': {
            borderBottom: '1px solid' + colors.lightBlue['200']
        }
    },
    focuses: {
        backgroundColor: 'white !important'
    },
    dialogPaper: {
        padding: 24,
        backgroundColor: theme.palette.background.default
    }
}));




const UpdatePopup = ({ setData, setShowSnackbar, data, openDialog, onClose }) => {
    const dataProvider = useDataProvider()
    const translate = useTranslate()
    const { permissions, loaded } = usePermissions();
    const [loadingButton, setLoadingButton] = useState(false)
    const [loadingPage, setLoadingPage] = useState(false)
    const [channels, setChannels] = React.useState(null)
    const [channelsAssign, setChannelsAssign] = React.useState(null)
    const [anchorEl, setAnchorEl] = React.useState(null);
    const [openPoper, setOpenPopper] = React.useState(false);
    const [errorSubmit, setErrorSubmit] = React.useState("");
    const [textValue, setTextValue] = React.useState({
        name: '',
        description: ''
    })
    const [openFile, setOpenFile] = useState({
        status: false,
        defaultId: 1,
        format: '',
        setResponse: null
    })
    const [logo, setLogo] = useState()
    const [error, setError] = useState({
        name: { status: true, message: '' },
    })
    const classes = useStyles()


    const onChangTextValue = (event, name) => {
        setTextValue({ ...textValue, [name]: event.target.value })
        if (event.target.value.length === 0 && name === 'name')
            setError({ ...error, [name]: { status: true, message: 'required' } })
        else
            setError({ ...error, [name]: { status: false, message: '' } })
    }

    const handleOpenFileDialog = () => {
        setOpenFile({
            status: true,
            defaultId: 4,
            format: isImage,
            setResponse: setLogo
        })
    }

    const handleCloseFile = () => {
        setOpenFile({
            status: false,
            defaultId: 1,
            format: '',
            setResponse: null
        })
    }

    const handleClickOpenPoper = (event) => {
        setAnchorEl(event.currentTarget);
        setOpenPopper(true);
    };

    const handleClosePoper = () => {
        setOpenPopper(false);
    };

    const onCreate = () => {
        setLoadingButton(true)
        dataProvider('CREATE', "medias/createcategory", {
            data: {
                name: textValue.name,
                description: textValue.description,
                icon: logo
            }
        })
            .then((response) => {
                let temps = data.slice()
                temps.unshift(response.data)
                setData(temps)
                onClose()
                setLoadingButton(false)
                setShowSnackbar({
                    status: true,
                    name: response.data.name,
                    message: translate(`pos.categories.createFolder.success`)
                })
                setTimeout(() => {
                    setShowSnackbar({
                        name: '',
                        message: '',
                        status: false
                    })
                }, 6000);
            })
            .catch(error => {
            })
    }

    const onSave = () => {
        setLoadingButton(true)

        dataProvider('UPDATE', "medias/editcategory", {
            id: openDialog.data.id,
            data: {
                name: textValue.name,
                description: textValue.description,
                icon: logo
            }
        })
            .then((response) => {
                let temps = data.slice()
                let index = temps.findIndex(e => e.id === openDialog.data.id)
                temps[index] = {
                    name: textValue.name,
                    description: textValue.description,
                    icon: logo
                }
                setData(temps)
                onClose()
                setLoadingButton(false)
                setShowSnackbar({
                    status: true,
                    name: textValue.name,
                    message: translate(`pos.categories.editFolder.success`)
                })
                setTimeout(() => {
                    setShowSnackbar({
                        name: '',
                        message: '',
                        status: false
                    })
                }, 6000);
            })
            .catch(error => {
            })
    }



    React.useEffect(() => {
        if (!openDialog.data) {
            setTextValue({
                name: '',
                description: ''
            })
            setError({
                name: { status: true, message: '' },
            })
            setErrorSubmit('')

        }
        else {
            setErrorSubmit('')
            setTextValue({
                name: openDialog.data.name,
                description: openDialog.data.description
            })
            setError({
                name: { status: false, message: '' }
            })
            setLogo(openDialog.data.icon)
        }

    }, [openDialog])

    useEffect(() => {
        if (openDialog.status !== true) {
            setLogo()
            setTextValue({
                name: '',
                description: ''
            })
        }

    }, [openDialog.status])

    if (!loaded) return null
    return (
        <Dialog scroll="paper" open={openDialog.status} classes={{
            paper: classes.dialogPaper
        }}>
            <Box>
                <Box display='flex' justifyContent='flex-end' alignContent='center'>
                    <Typography style={{ margin: 'auto 8px auto 0' }} variant='subtitle2'>{translate(`pos.common.close`)}</Typography>
                    <CloseButton onClick={onClose}/>
                </Box>
                <Box ml={3}>
                    <Typography variant='h5'>{
                        !openDialog.data ? translate(`pos.media.createCategory`) : translate(`pos.categories.edit`)
                    }</Typography>
                    {
                        openDialog.data &&
                        <Typography variant='subtitle2'>{
                            openDialog.data.name
                        }</Typography>
                    }
                </Box>

            </Box>
            <DialogContent dividers={false}>
                {
                    errorSubmit != "" && (
                        <Box borderRadius='6px' my={1} bgcolor={bgColorError} py={1}>
                            <Typography className={classes.TextValue} style={{ color: textColorError, margin: '1em' }}>{errorSubmit}</Typography>
                        </Box>
                    )
                }

                <Box my={2} display='flex' justifyContent='center'>
                    <TextField
                        required
                        style={{ width: 500 }}
                        variant="filled"
                        error={error.name.status && error.name.message !== ''}
                        helperText={error.name.message}
                        value={textValue.name}
                        label={translate(`pos.common.name`)}
                        onBlur={(event) => onChangTextValue(event, 'name')}
                        onChange={(event) => onChangTextValue(event, 'name')}
                        InputProps={{
                            endAdornment:
                                <CustomPoper
                                    open={openPoper}
                                    anchorEl={anchorEl}
                                    handleClick={handleClickOpenPoper}
                                    handleClose={handleClosePoper}
                                    title={translate(`pos.channels.groupNameTitle`)}
                                    content={translate(`pos.channels.groupName`)}
                                    icon={<b>?</b>}
                                />,
                            className: classes.input,
                            classes: {
                                underline: textValue.name !== '' ? classes.underline : classes.underlineNotValue,
                                focused: classes.focuses
                            }
                        }}
                    />
                </Box>
                <Box my={2} display='flex' justifyContent='center'>
                    <TextField
                        variant="filled"
                        multiline
                        rows={2}
                        style={{ width: 500 }}
                        label={translate(`pos.support.description`)}
                        value={textValue.description}
                        onChange={(event) => onChangTextValue(event, 'description')}
                        InputProps={{
                            endAdornment:
                                <CustomPoper
                                    open={openPoper}
                                    anchorEl={anchorEl}
                                    handleClick={handleClickOpenPoper}
                                    handleClose={handleClosePoper}
                                    title={translate(`pos.support.description`)}
                                    content={translate(`pos.media.descriptionCategoryMedia`)}
                                    icon={<b>?</b>}
                                />,
                            className: classes.input,
                            classes: {
                                underline: textValue.description !== '' ? classes.underline : classes.underlineNotValue,
                                focused: classes.focuses
                            }
                        }}
                    />
                </Box>
                <Box my={2}>
                    <Card style={{ marginTop: "1em" }} className={classes.borderUpImange} >
                        <Grid container style={{ marginTop: "1em" }} item xs={12} sm={12} xl={12} lg={12} >
                            <Grid>
                                {
                                    logo && <img src={baseApiUrl + '/media/' + JSON.parse(logo).fd} className={classes.large} />
                                }

                            </Grid>
                            <Grid>
                                <CardContent>
                                    <Typography className={classes.TitleImage} gutterBottom>
                                        {translate(`pos.user.changeimage`)}
                                    </Typography>
                                    <Box my={1}>
                                        <Button
                                            onClick={handleOpenFileDialog}
                                            className={classes.borderImage} color='primary'>{translate(`pos.media.chooseIcon`)}</Button>
                                    </Box>
                                    {logo && <Typography style={{ width: 250, overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis' }}>{`${JSON.parse(logo).filepath}`}</Typography>}
                                </CardContent>
                            </Grid>
                        </Grid>
                    </Card>
                    <DialogChooseFile
                        isSetPath={true}
                        formats={openFile.format}
                        defaultId={openFile.defaultId}
                        open={openFile.status}
                        pickerMode='pickMediaOnly'
                        handleClose={handleCloseFile}
                        setChooseValue={openFile.setResponse}
                        isPermission={permissions.functionAction.find((value) => value.function === 'File manager (CRUD)' && (value.isRead || value.isUpdate))}
                    />
                </Box>
            </DialogContent>
            <DialogActions>
                <Box mt={1} mr={1.5} display='flex' justifyContent='flex-end' width='100%'>
                    <Button color='primary' onClick={onClose}>{translate(`pos.common.cancel`)}</Button>
                    <Button
                        disabled={error.name.status || loadingButton}
                        style={{ marginLeft: 8 }}
                        variant='contained'
                        color='primary'
                        onClick={openDialog.data ? onSave : onCreate}
                    >
                        {loadingButton ? (
                            <CircularProgress
                                size={15}
                                thickness={2}
                                color='inherit'
                            />
                        ) :
                            (!openDialog.data ? translate(`pos.common.create`) : translate(`pos.common.save`))
                        }
                    </Button>
                </Box>
            </DialogActions>
        </Dialog>
    )
}

export default UpdatePopup